import React, { useEffect } from 'react';

const Sitemap = () => {
  useEffect(() => {
    // XML content of your sitemap
    const sitemapContent = `<?xml version="1.0" encoding="UTF-8"?>
        <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
        <!-- Homepage -->
        <url>
            <loc>https://momentcentral.momentgolf.com/</loc>
            <lastmod>2025-3-7</lastmod>
            <changefreq>weekly</changefreq>
            <priority>1.0</priority>
        </url>
        
        <!-- Main pages -->
        <url>
            <loc>https://momentcentral.momentgolf.com/myAccount</loc>
            <lastmod>2025-3-7</lastmod>
            <changefreq>monthly</changefreq>
            <priority>0.8</priority>
        </url>
        
        <!-- Add more URLs as needed -->
        </urlset>`;

    // Set the content type to XML
    document.head.innerHTML = '<title>Sitemap</title>';
    
    // Create a pre element and set its content to the XML
    const pre = document.createElement('pre');
    pre.textContent = sitemapContent;
    
    // Clear the body and append the pre element
    document.body.innerHTML = '';
    document.body.appendChild(pre);
    
    // Set the content type using a meta tag
    const meta = document.createElement('meta');
    meta.httpEquiv = 'Content-Type';
    meta.content = 'text/xml; charset=utf-8';
    document.head.appendChild(meta);
  }, []);

  return null;
};

export default Sitemap;